package com.ijoin.platform

/**
 * JS implementation – redirects in the same tab. Callback arrives via page redirect.
 */
actual fun startOAuthFlow(
    url: String,
    callbackScheme: String,
    onCallbackUrl: (String?) -> Unit,
) {
    redirectToUrl(url)
    onCallbackUrl(null)
}
